import { useAuthContext } from '@/hooks/useAuthContext';
import navsConfig from '@/routes/nav';
import { useCompanyCategory } from '@hooks/useCompanyCategory';

const useNavConfig = (): {
  lastNav: Record<string, any>[];
  newNav: Record<string, any>[];
} => {
  const { user, subscriptions } = useAuthContext();
  const { isFoodCompany } = useCompanyCategory();

  const newNav: Record<string, any>[] = [];
  const lasNav: Record<string, any>[] = [];
  navsConfig.forEach((nav) =>
    nav(user?.role?.id, subscriptions?.data?.features ?? []).forEach((item, index) => {
      if (index === 0) {
        lasNav.push(item);
      }
      newNav.push(item);
    })
  );
  if (!subscriptions?.data?.isActive) {
    return {
      lastNav: [
        {
          key: 'Adquiere tu licencia',
          title: 'Adquiere tu licencia',
          items: lasNav.filter((item) => !!item?.title && !item.hide && item.active),
        },
      ],
      newNav: [
        {
          key: 'Adquiere tu licencia',
          title: 'Adquiere tu licencia',
          items: newNav.filter((item) => !!item?.title && !item.hide && item.active),
        },
      ],
    };
  }

  return {
    lastNav: [
      {
        key: 'Dashboard',
        title: 'Dashboard',
        items: lasNav.filter(
          (item) =>
            !!item?.title &&
            !item.hide &&
            (!item.isFoodCompany || (isFoodCompany && item.isFoodCompany))
        ),
      },
    ],
    newNav: [
      {
        key: 'Dashboard',
        title: 'Dashboard',
        items: newNav.filter(
          (item) =>
            !!item?.title &&
            !item.hide &&
            (!item.isFoodCompany || (isFoodCompany && item.isFoodCompany))
        ),
      },
    ],
  };
};

export default useNavConfig;
